import has from 'mout/object/has'
import forOwn from 'mout/object/forOwn'

export default function checkAnySubtestCompletions (groupUA) {
  if (has(groupUA, 'scoring.bySubtest')) {
    let output = false
    forOwn(groupUA.scoring.bySubtest, (subtest) => {
      if (has(subtest, 'studentCount')) {
        if (subtest.studentCount) {
          output = true
        }
      }
    }) 
    return output
  } else {
    return false
  }
}


// WEBPACK FOOTER //
// ./src/helpers/assessment/checkAnySubtestCompletions.js